// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1Yht9","title":"AfterFrontImage_title__111ag"};